import MGR from '../interceptors/MgrPublic';

export const verifyCode = (data) => MGR.post('/users/code', data);

export const resendCode = (data) => MGR.put('/users/code/resend', data);
